import { MainPage } from './MainPage';
import { PlusMainPage } from './PlusMainPage';

export const mainRouter = {
  '/': MainPage,
  '@plus': PlusMainPage,
};
